import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { injectIntl, intlShape, FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import { Card, CardBody, Button, Alert } from 'reactstrap';
import FontAwesome from 'react-fontawesome';

import { parseQuery } from '../../../../util/parser';

import { validPaymentRequest, getOrder } from '../../../Order/OrderActions';
import { trackAnalytics, clearCart } from '../../CartActions';
import { getLanguagePath } from '../../../Intl/IntlActions';

import FontCustom from '../../../../components/Content/FontCustom';


class CartConfirmation extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            hasError: false,
        };
    }

    componentDidMount() {
        const transaction = parseQuery(this.props.location.search);
        if(transaction && transaction.orderID) {
            this.setState({
                isLoading: true,
            });
            const [orderId, paymentId, time] = transaction.orderID.split('/');
            this.props.dispatch(validPaymentRequest(this.props.orderId, paymentId, transaction)).then(order => {
                const payment = order && (order.payments || []).find(payment => payment.id === paymentId);
                payment && payment.status === 'complete' && trackAnalytics(order);
                this.setState({
                    isLoading: false,
                    hasError: !order || !payment /* || payment.status !== 'complete' */,
                });

                if(order) {
                    // Set Analytics data
                }
            });
        }

        this.props.dispatch(clearCart());
    }

    render() {
        const { order } = this.props;
        if(order) {
            return (
                <Fragment>
                    <Card className="mt-5">
                        <CardBody className="text-center">
                            {
                                this.state.isLoading
                                ? (
                                    <Alert color="success" className="text-center">
                                        <h3><FontAwesome name="spinner" spin size="lg" /> <FormattedMessage id="cartConfirmationLoadingText" defaultMessage="We are processing your order..." /></h3>
                                    </Alert>
                                )
                                : (
                                    <Fragment>
                                        {
                                            this.state.hasError
                                            ? (
                                                <Fragment>
                                                    <h3 className="mb-3"><FormattedHTMLMessage id="cartErrorTitle" defaultMessage="Something goes wrong..." /></h3>
                                                    <p className="mb-3">
                                                        <FormattedMessage id="CartPaymentErrorText" defaultMessage="Your payment failed! Please check your order and retry your payment..." />
                                                        <Button color="warning" tag={Link} to={getLanguagePath(`/orders/${order.code}`, this.props.intl.locale)} className="mt-3"><FormattedMessage id="orderViewButton" defaultMessage="View my order" /></Button>
                                                    </p>
                                                </Fragment>
                                            )
                                            : (
                                                <Fragment>
                                                    <h3 className="mb-3"><FormattedHTMLMessage id="cartConfirmationTitle" defaultMessage="Thank you! <br /> Your order <a href={link} class='text-warning text-underline'>{orderNumber}</a> is validated." values={{ link: getLanguagePath(`/orders/${order.code}`, this.props.intl.locale), orderNumber: order.code }} /></h3>
                                                    <p className="mb-3">
                                                        {
                                                            order.status === 'pendingpayment'
                                                            ? <FormattedMessage id="cartPendinpPaymentText" defaultMessage="We are waiting your payment to process your order... " />
                                                            : <FormattedHTMLMessage id="cartConfirmationText" defaultMessage="You'll receive a confirmation mail,<br />Your order will be visible and you can follow it via <a href={link}>your account</a>." values={{ link: getLanguagePath('/user/profile', this.props.intl.locale) }} />
                                                        }
                                                    </p>
                                                    <h3 className="mb-3"><FormattedMessage id="cartConfirmationSubText" defaultMessage="Come and chat on social networks" /></h3>
                                                    <a href="https://facebook.com/atremoplus" target="_blank" className="text-warning"><FontCustom name="facebook" size="3" /></a>
                                                </Fragment>
                                            )
                                        }
                                    </Fragment>
                                )
                            }
                        </CardBody>
                    </Card>
                </Fragment>
            );
        }
        return null;
    }
}

function mapStateToProps(store, props) {
    return {
        order: getOrder(store, props.orderId),
    };
}

CartConfirmation.defaultProps = {
    order: null,
};

CartConfirmation.propTypes = {
    location: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    intl: intlShape.isRequired,
    orderId: PropTypes.string.isRequired,
    order: PropTypes.object,
};


export default connect(mapStateToProps)(withRouter(injectIntl(CartConfirmation)));
